// ============================================================
// FILE: _services/ecg-standalone11/ecg-standalone11-signal-processor.ts
//
// Ported verbatim from EcgConnectStandalone11's
// src/app/ecg/ecg-signal-processor.ts. FIR_B_5_40 (501-tap bandpass, 5-40 Hz
// @ 500 Hz sampling) and the whole LiveEcgProcessor pipeline (baseline IIR
// pre-filter, FIR convolution, warm-up/DC-baseline bookkeeping, Einthoven/
// Goldberger + hardware-channel-scramble lead derivation) are copied
// unchanged -- do not "clean up" without re-verifying against real hardware,
// same caution as this app's other ported device managers.
//
// Leads12/Ecg11LeadOffFlags live in @core/interfaces/device-integration/
// device-item.model.ts (this app's convention for device state shapes)
// rather than being declared inline here as the reference app does.
// ============================================================
import { Ecg11LeadOffFlags, Leads12 } from '../../@core/interfaces/device-integration/device-item.model';

export const FIR_B_5_40: number[] = [
  -2.32e-21, -2.31e-7, -4.18e-7, -5.21e-7, -5.09e-7, -3.71e-7, -1.24e-7, 1.89e-7,
  4.95e-7, 7.06e-7, 7.4e-7, 5.42e-7, 1.08e-7, -4.98e-7, -1.15e-6, -1.68e-6,
  -1.93e-6, -1.76e-6, -1.17e-6, -2.41e-7, 8.07e-7, 1.68e-6, 2.06e-6, 1.74e-6,
  6.25e-7, -1.14e-6, -3.21e-6, -5.11e-6, -6.32e-6, -6.42e-6, -5.26e-6, -3.0e-6,
  -1.49e-7, 2.54e-6, 4.21e-6, 4.19e-6, 2.12e-6, -1.83e-6, -6.97e-6, -1.22e-5,
  -1.62e-5, -1.78e-5, -1.64e-5, -1.21e-5, -5.86e-6, 8.11e-7, 5.96e-6, 7.8e-6,
  5.21e-6, -1.91e-6, -1.25e-5, -2.43e-5, -3.47e-5, -4.09e-5, -4.11e-5, -3.48e-5,
  -2.32e-5, -9.16e-6, 3.51e-6, 1.09e-5, 9.98e-6, -3.6e-7, -1.89e-5, -4.22e-5,
  -6.5e-5, -8.19e-5, -8.83e-5, -8.19e-5, -6.38e-5, -3.81e-5, -1.15e-5, 8.33e-6,
  1.47e-5, 3.66e-6, -2.44e-5, -6.47e-5, -0.000108809, -0.000146504, -0.000168258, -0.000167877,
  -0.000144435, -0.000103033, -5.4e-5, -1.08e-5, 1.35e-5, 9.42e-6, -2.6e-5, -8.79e-5,
  -0.000163984, -0.000237233, -0.000289965, -0.000308341, -0.000286354, -0.000228088, -0.000147517, -6.57e-5,
  -5.9e-6, 1.23e-5, -2.14e-5, -0.000104926, -0.000223042, -0.000350329, -0.000457014, -0.000516366,
  -0.000511898, -0.000442483, -0.000323859, -0.000185863, -6.58e-5, 8.03e-7, -1.07e-5, -0.000106555,
  -0.000271781, -0.000472378, -0.000662752, -0.000796672, -0.000839208, -0.000776611, -0.000621421, -0.00041112,
  -0.000200233, -4.74e-5, -6.6e-7, -8.4e-5, -0.000289662, -0.000578006, -0.000885342, -0.001138843,
  -0.001274693, -0.001255172, -0.00108015, -0.000789647, -0.000456199, -0.000168324, -8.77e-6, -3.28e-5,
  -0.000252225, -0.000629454, -0.001084052, -0.001510646, -0.001804449, -0.001888239, -0.001733959, -0.001373016,
  -0.000891935, -0.000413561, -6.78e-5, 4.15e-5, -0.000135592, -0.000578567, -0.001197681, -0.00185273,
  -0.002385966, -0.002661486, -0.002601373, -0.002209112, -0.001573514, -0.000851, -0.000229514, 0.000117757,
  7.76e-5, -0.000370859, -0.001145269, -0.002075357, -0.00294131, -0.003527173, -0.00367627, -0.003334639,
  -0.002570662, -0.00156453, -0.000568536, 0.000153297, 0.000391983, 5.0e-5, -0.000827376, -0.002055961,
  -0.00335153, -0.004396922, -0.004921061, -0.004770672, -0.003955934, -0.002657005, -0.001187571, 7.77e-5,
  0.000795066, 0.000741372, -0.000122694, -0.00163212, -0.003448175, -0.005134903, -0.00626465, -0.006527387,
  -0.005816267, -0.004266332, -0.002233912, -0.000218613, 0.001255556, 0.00177204, 0.001133887, -0.000573399,
  -0.002987048, -0.005542887, -0.007606745, -0.00863138, -0.008300706, -0.006624088, -0.003953885, -0.000917203,
  0.001726111, 0.00326789, 0.003234581, 0.001522491, -0.001551726, -0.005303447, -0.008828776, -0.011218479,
  -0.011787782, -0.010265472, -0.006892185, -0.002397039, 0.002150081, 0.005582621, 0.006924064, 0.005649173,
  0.001853114, -0.003720423, -0.009810046, -0.01490696, -0.017609907, -0.016985209, -0.012844981, -0.00586923,
  0.002471241, 0.010190749, 0.015216579, 0.015882976, 0.011383552, 0.002075445, -0.010446253, -0.023540265,
  -0.033957747, -0.038453463, -0.034453436, -0.020643939, 0.002644405, 0.033347641, 0.067908401, 0.101812984,
  0.130332805, 0.149333722, 0.156, 0.149333722, 0.130332805, 0.101812984, 0.067908401, 0.033347641,
  0.002644405, -0.020643939, -0.034453436, -0.038453463, -0.033957747, -0.023540265, -0.010446253, 0.002075445,
  0.011383552, 0.015882976, 0.015216579, 0.010190749, 0.002471241, -0.00586923, -0.012844981, -0.016985209,
  -0.017609907, -0.01490696, -0.009810046, -0.003720423, 0.001853114, 0.005649173, 0.006924064, 0.005582621,
  0.002150081, -0.002397039, -0.006892185, -0.010265472, -0.011787782, -0.011218479, -0.008828776, -0.005303447,
  -0.001551726, 0.001522491, 0.003234581, 0.00326789, 0.001726111, -0.000917203, -0.003953885, -0.006624088,
  -0.008300706, -0.00863138, -0.007606745, -0.005542887, -0.002987048, -0.000573399, 0.001133887, 0.00177204,
  0.001255556, -0.000218613, -0.002233912, -0.004266332, -0.005816267, -0.006527387, -0.00626465, -0.005134903,
  -0.003448175, -0.00163212, -0.000122694, 0.000741372, 0.000795066, 7.77e-5, -0.001187571, -0.002657005,
  -0.003955934, -0.004770672, -0.004921061, -0.004396922, -0.00335153, -0.002055961, -0.000827376, 5.0e-5,
  0.000391983, 0.000153297, -0.000568536, -0.00156453, -0.002570662, -0.003334639, -0.00367627, -0.003527173,
  -0.00294131, -0.002075357, -0.001145269, -0.000370859, 7.76e-5, 0.000117757, -0.000229514, -0.000851,
  -0.001573514, -0.002209112, -0.002601373, -0.002661486, -0.002385966, -0.00185273, -0.001197681, -0.000578567,
  -0.000135592, 4.15e-5, -6.78e-5, -0.000413561, -0.000891935, -0.001373016, -0.001733959, -0.001888239,
  -0.001804449, -0.001510646, -0.001084052, -0.000629454, -0.000252225, -3.28e-5, -8.77e-6, -0.000168324,
  -0.000456199, -0.000789647, -0.00108015, -0.001255172, -0.001274693, -0.001138843, -0.000885342, -0.000578006,
  -0.000289662, -8.4e-5, -6.6e-7, -4.74e-5, -0.000200233, -0.00041112, -0.000621421, -0.000776611,
  -0.000839208, -0.000796672, -0.000662752, -0.000472378, -0.000271781, -0.000106555, -1.07e-5, 8.03e-7,
  -6.58e-5, -0.000185863, -0.000323859, -0.000442483, -0.000511898, -0.000516366, -0.000457014, -0.000350329,
  -0.000223042, -0.000104926, -2.14e-5, 1.23e-5, -5.9e-6, -6.57e-5, -0.000147517, -0.000228088,
  -0.000286354, -0.000308341, -0.000289965, -0.000237233, -0.000163984, -8.79e-5, -2.6e-5, 9.42e-6,
  1.35e-5, -1.08e-5, -5.4e-5, -0.000103033, -0.000144435, -0.000167877, -0.000168258, -0.000146504,
  -0.000108809, -6.47e-5, -2.44e-5, 3.66e-6, 1.47e-5, 8.33e-6, -1.15e-5, -3.81e-5,
  -6.38e-5, -8.19e-5, -8.83e-5, -8.19e-5, -6.5e-5, -4.22e-5, -1.89e-5, -3.6e-7,
  9.98e-6, 1.09e-5, 3.51e-6, -9.16e-6, -2.32e-5, -3.48e-5, -4.11e-5, -4.09e-5,
  -3.47e-5, -2.43e-5, -1.25e-5, -1.91e-6, 5.21e-6, 7.8e-6, 5.96e-6, 8.11e-7,
  -5.86e-6, -1.21e-5, -1.64e-5, -1.78e-5, -1.62e-5, -1.22e-5, -6.97e-6, -1.83e-6,
  2.12e-6, 4.19e-6, 4.21e-6, 2.54e-6, -1.49e-7, -3.0e-6, -5.26e-6, -6.42e-6,
  -6.32e-6, -5.11e-6, -3.21e-6, -1.14e-6, 6.25e-7, 1.74e-6, 2.06e-6, 1.68e-6,
  8.07e-7, -2.41e-7, -1.17e-6, -1.76e-6, -1.93e-6, -1.68e-6, -1.15e-6, -4.98e-7,
  1.08e-7, 5.42e-7, 7.4e-7, 7.06e-7, 4.95e-7, 1.89e-7, -1.24e-7, -3.71e-7,
  -5.09e-7, -5.21e-7, -4.18e-7, -2.31e-7, -2.32e-21,
];

export const FIR_ORDER = 500; // matches vendor app: FIR_B_5_40.length - 1
export const ECG11_SAMPLING_RATE = 500;
export const ECG11_RAW_CHANNEL_COUNT = 8;
export const ECG11_WARMUP_SAMPLES = 1300; // matches vendor app: total_samples(6500) / 5
const XAXIS_WD = ECG11_WARMUP_SAMPLES;

const LEAD_KEYS: (keyof Leads12)[] = ['I', 'II', 'III', 'aVR', 'aVL', 'aVF', 'V1', 'V2', 'V3', 'V4', 'V5', 'V6'];

function toLeads12(arr: number[]): Leads12 {
  const out: any = {};
  LEAD_KEYS.forEach((key, i) => (out[key] = arr[i]));
  return out as Leads12;
}

// Lead-off (electrode not making contact) detection, decoded directly from
// the device's own status bits.
//   status1: 0x08=V1  0x04=V5  0x02=V3  0x01=V4
//   status2: 0x80=V2  0x40=LL  0x20=LA  0x10=V6
//   status3: 0x20=RA
// RA/LA/LL are raw electrode positions, not leads on their own -- I and II
// are derived from them (I = LA-RA, II = LL-RA), so either electrode being
// off makes that lead unreliable. Only present on full frames (SOF 0xAA) --
// short frames (0xBB) carry no status bytes, so callers should hold the
// last known flags rather than clear them when status is null.
export function computeLeadOffFromStatus(status: { status1: number; status2: number; status3: number } | null): Ecg11LeadOffFlags {
  if (!status) return {};
  const { status1, status2, status3 } = status;
  const V1 = (status1 & 0x08) !== 0;
  const V5 = (status1 & 0x04) !== 0;
  const V3 = (status1 & 0x02) !== 0;
  const V4 = (status1 & 0x01) !== 0;
  const V2 = (status2 & 0x80) !== 0;
  const LL = (status2 & 0x40) !== 0;
  const LA = (status2 & 0x20) !== 0;
  const V6 = (status2 & 0x10) !== 0;
  const RA = (status3 & 0x20) !== 0;
  return {
    I: RA || LA,
    II: RA || LL,
    V1, V2, V3, V4, V5, V6,
  };
}

/**
 * Direct port of the vendor app's LiveEcgProcessor. Per-tick pipeline:
 *   1. Per-channel 0.992-pole IIR high-pass (removes DC/baseline wander)
 *   2. 500-order FIR bandpass convolution (5-40 Hz), skipped during the
 *      warm-up window
 *   3. Einthoven/Goldberger derivation of III/aVR/aVL/aVF from filtered I/II
 *   4. A DC baseline average (per lead) accumulated during the first
 *      XAXIS_WD (1300) samples, then subtracted from every sample after
 *      that.
 * Returns null during the warm-up window (nothing to plot yet).
 */
export class Ecg11LiveProcessor {
  private coeffs: number[];
  private readonly order = FIR_ORDER;

  private tempADS: Float64Array[] = Array.from({ length: ECG11_RAW_CHANNEL_COUNT }, () => new Float64Array(FIR_ORDER + 1));
  private tempIndex = 0;

  private preIirX = new Float64Array(ECG11_RAW_CHANNEL_COUNT);
  private preIirY = new Float64Array(ECG11_RAW_CHANNEL_COUNT);

  private dc = new Float64Array(12);
  private ave = new Float64Array(12);
  private samplesSeen = 0;
  private initDone = false;
  private readonly filterOn = true;

  constructor(coeffs: number[] = FIR_B_5_40) {
    this.coeffs = coeffs;
  }

  reset(): void {
    for (let ch = 0; ch < ECG11_RAW_CHANNEL_COUNT; ch++) {
      this.tempADS[ch].fill(0);
      this.preIirX[ch] = 0;
      this.preIirY[ch] = 0;
    }
    this.dc.fill(0);
    this.ave.fill(0);
    this.samplesSeen = 0;
    this.initDone = false;
    this.tempIndex = 0;
  }

  get isWarmedUp(): boolean {
    return this.initDone;
  }

  processSample(raw8: number[]): Leads12 | null {
    const filtered8 = new Float64Array(ECG11_RAW_CHANNEL_COUNT);
    const warmingUp = !this.initDone && this.samplesSeen <= this.order;

    for (let ch = 0; ch < ECG11_RAW_CHANNEL_COUNT; ch++) {
      const rawIn = Number(raw8[ch]) || 0;

      // 1. Moving baseline drift filter (0.992 IIR pole).
      this.preIirY[ch] = rawIn - this.preIirX[ch] + 0.992 * this.preIirY[ch];
      this.preIirX[ch] = rawIn;
      this.tempADS[ch][this.tempIndex] = this.preIirY[ch];

      if (!this.filterOn) {
        filtered8[ch] = this.tempADS[ch][this.tempIndex];
        continue;
      }

      if (warmingUp) {
        filtered8[ch] = 0; // AVE[i] is still 0 until warm-up completes
        continue;
      }

      // 2. 500-order FIR bandpass convolution, walking the ring buffer
      // backward from the current write position.
      let firData = 0;
      let firCount = this.tempIndex;
      for (let i = 0; i <= this.order; i++) {
        firData += this.coeffs[i] * this.tempADS[ch][firCount];
        firCount = firCount === 0 ? this.order : firCount - 1;
      }
      filtered8[ch] = firData < 0 ? Math.ceil(firData) : Math.floor(firData);
    }

    this.tempIndex = this.tempIndex === this.order ? 0 : this.tempIndex + 1;

    // 3. Derive limb leads from filtered I/II.
    const I = filtered8[1];
    const II = filtered8[2];
    const III = II - I;
    const aVR = (-1 * (I + II)) / 2.0;
    const aVL = I - II / 2.0;
    const aVF = II - I / 2.0;

    // 4. Hardware-scrambled raw8 -> 12-lead mapping (NOT physiological
    // order): V1=raw7, V2=raw3, V3=raw5, V4=raw4, V5=raw6, V6=raw0.
    const leads12 = [I, II, III, aVR, aVL, aVF, filtered8[7], filtered8[3], filtered8[5], filtered8[4], filtered8[6], filtered8[0]];

    if (!this.initDone) {
      for (let ch = 0; ch < 12; ch++) {
        this.dc[ch] += leads12[ch];
      }

      if (this.samplesSeen === XAXIS_WD - 1) {
        const denom = this.filterOn ? XAXIS_WD - this.order : XAXIS_WD;
        for (let ch = 0; ch < 12; ch++) {
          const avg = this.dc[ch] / denom;
          this.ave[ch] = avg < 0 ? Math.ceil(avg) : Math.floor(avg);
        }
        this.initDone = true;
        this.samplesSeen = 0;
      } else {
        this.samplesSeen++;
      }
      return null; // nothing to plot yet
    }

    return toLeads12(leads12.map((v, ch) => v - this.ave[ch]));
  }
}
